import React from 'react';
import { PartsSellingGrossReport } from './PartsSellingGrossReport';
import { ServiceSellingGrossReport } from './ServiceSellingGrossReport';
import { NewSellingGrossReport } from './NewSellingGrossReport';
import { UsedSellingGrossReport } from './UsedSellingGrossReport';
import { BodySellingGrossReport } from './BodySellingGrossReport';
import { WholesaleComparisonReport } from './WholesaleComparisonReport';
import { AdExpenseComparisonReport } from './AdExpenseComparisonReport';
import { LeadPacingReport } from './LeadPacingReport';
import { TsmRankingReport } from './TsmRankingReport';
import { TsmItemsReport } from './TsmItemsReport';
import { SalesTeamPerformanceReport } from './SalesTeamPerformanceReport';
import { CeoDailyBriefingReport } from './CeoDailyBriefingReport';
import { SalesTeamFunnelReport } from './SalesTeamFunnelReport';

/**
 * Registry mapping reportId to its React renderer component.
 * Each renderer receives { data } where data is the report-specific payload.
 */
const renderers: Record<string, React.FC<{ data: any }>> = {
  'parts-gross-report': PartsSellingGrossReport,
  'service-gross-report': ServiceSellingGrossReport,
  'new-gross-report': NewSellingGrossReport,
  'used-gross-report': UsedSellingGrossReport,
  'body-gross-report': BodySellingGrossReport,
  'wholesale-comparison': WholesaleComparisonReport,
  'ad-expense-comparison': AdExpenseComparisonReport,
  'lead-pacing-report': LeadPacingReport,
  'tsm-ranking-report': TsmRankingReport,
  'tsm-items-report': TsmItemsReport,
  'sales-team-performance': SalesTeamPerformanceReport,
  'ceo-daily-briefing': CeoDailyBriefingReport,
  'sales-team-funnel-report': SalesTeamFunnelReport,
};

export function getReportRenderer(reportId: string): React.FC<{ data: any }> | null {
  return renderers[reportId] || null;
}
